import axios from '@/utils/axios';

/**
 * 发送验证码
 */
export function sendSms(phone) {
  return axios.formRequest.post('pay/pay/sendSms', { phone });
}

/**
 * 搜索用产品列表
 */
export function getGoodsList() {
  return axios.formRequest.post('empower/website/empower/goods_list', { });
}
